export default __webpack_public_path__ + "static/PromptIconFive-df19e1031df8f9b591ae75cee097bdbe.png";